// extracted by mini-css-extract-plugin
module.exports = {"container":"TermsAndConditions_container__39-P0"};